<template>
  <section
    class="info-site content-padd"
    :class="{ isMobile }"
    id="baza_wiedzy"
  >
    <div class="content-width">
      <div class="info-content">
        <div class="info-left">
          <h2 class="title-underline icons-title color-primary-purple">
            Baza wiedzy
          </h2>
          <div class="phone-img">
            <img src="/img/phone.svg" alt="phone-image" />
          </div>
          <h3
            class="info-cont-title"
            v-html="'Skontaktuj się z&nbsp;nami'"
          ></h3>
          <address class="info-cont-cont">
            <div>e-budownictwo@gunb.gov.pl</div>
            <div>
              Infolinia: (22) 295 51 28 <span>(pn.-pt. 10:00-13:00)</span>
            </div>
          </address>
          <div>
            <LibLink
              text="Prawo budowlane"
              textBottom="Wyjaśnienie przepisów prawa"
              link="https://www.gov.pl/web/gunb/wyjasnienia-przepisow-prawa-budowlanego"
              :mobile="isMobile"
              class="mb-4"
            />
            <LibLink
              text="Akademia GUNB"
              textBottom="Przejdź do akademii GUNB"
              link="https://akademia.gunb.gov.pl"
              :mobile="isMobile"
            />
          </div>
          <!-- <div>
            <LibHomeSectionLinkBox
              class="link-box"
              title="Wzory wniosków, zgłoszeń i&nbsp;zawiadomień"
              text="Przeglądaj wzory dokumentów w zasobach GUNB"
              link="https://www.gov.pl/web/gunb/wzory-wnioskow-zgloszen-i-zawiadomien"
              :mobile="isMobile"
            />
            <LibHomeSectionLinkBox
              class="link-box"
              title="Prawo budowlane"
              text="Wyjaśnienia przepisów prawa <br> budowlanego"
              link="https://www.gov.pl/web/gunb/wzory-wnioskow-zgloszen-i-zawiadomien"
              :mobile="isMobile"
            />
          </div> -->
        </div>
        <div class="info-right edited-html">
          <div class="right-title">Pytania i odpowiedzi</div>
          <LibHomeMultiExpandedItem
            v-for="(FAQItem, index) in FAQ"
            :key="index"
            :title="FAQItem.title"
            :text="FAQItem.text"
            :items="FAQItem.items"
            :mobile="isMobile"
            class="mb-2"
          />
        </div>
      </div>
    </div>
  </section>
</template>
<script>
// import LibHomeSectionLinkBox from "./LibHomeSectionLinkBox.vue";
import LibLink from "./LibLink.vue";
import LibHomeMultiExpandedItem from "./LibHomeMultiExpandedItem.vue";
// import { FAQ } from "../data";
const code = "FAQ";
export default {
  name: "LibHomeSectionInfo",
  components: { LibHomeMultiExpandedItem, LibLink },
  data() {
    return {
      FAQ: []
    };
  },

  methods: {
    loadData() {
      const content = this.$store.getters["layout/getPage"](code);
      if (content) {
        this.parseContent(content);
        return;
      }
      this.$store.commit("layout/showOverlay");
      this.$axios
        .get(`/configurations/pages/${code}`)
        .then(({ data }) => {
          this.parseContent(data.content);
          this.$store.commit("layout/setPage", {
            code: code,
            html: data.content
          });
        })
        .catch((e) => {
          console.log(e.response);
          this.$store.commit(
            "layout/showErrorDialog",
            this.getMessageMixin("getDataError")
          );
        })
        .finally(() => {
          this.$store.commit("layout/hideOverlay");
        });
    },
    parseContent(content) {
      try {
        this.FAQ = JSON.parse(content);
      } catch (error) {
        console.error("Failed to parse JSON:", error.message);
      }
    }
  },
  created() {
    this.loadData();
  }
};
</script>

<style lang="scss" scoped>
@import "@/scss/mixins.scss";
.info-site {
  position: relative;
}

.info-content {
  display: flex;
}

.info-left {
  width: min(100%, 420px);
  margin-right: min(8%, 105px);
}
.info-right {
  flex: 1 0;
}

.phone-img {
  margin-top: 4rem;
}

.info-cont-title {
  margin-top: 0.6rem;
  font-size: 2rem;
  font-weight: 700;
  line-height: 2.8rem;
  @include purple();
}

.info-cont-cont {
  margin-top: 0.8rem;
  margin-bottom: 4rem;
  font-weight: 500;
  font-style: normal;
  @include purple();
}

.link-box {
  margin-top: 24px;
}
.right-title {
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 5rem;
  @include purple();
}
.isMobile {
  .info-content {
    display: block;
  }
  .info-left {
    margin-bottom: 46px;
    margin-right: 0;
  }
  .right-title {
    margin-bottom: 46px;
  }

  .phone-img {
    margin-top: 4rem;
  }
}
</style>
